import {reqVerifycode,register,login,userinfo,getUid, enquiry,gethistory,updatehistory} from '@/api';
// 用来存储数据
const state = {
    codeStatus:1,
    regStatus:null,
    msg1:'',
    msg2:'',
    token:localStorage.getItem('token'),
    userinfo:{
        name:''
    },
    history:[
        
    ],
}
// 响应组件中的事件
const actions = {
    async getcode({commit},params){
        let result = await reqVerifycode(params);
        if(result.code == 200){
            commit('codeStatus',result.data);
        }
        
    },
    async register({commit},params){
        let result = await register(params);
        if(result.code == 200){
            commit('regStatus',result.data);
        }
        
    },
    async login({commit},params){
        let result = await login(params);
        if(result.code == 200){
            commit("login",result.token);
            localStorage.setItem('token',result.token);
        } else {
            return Promise.reject(new Error('账号或密码错误'));
        }
    },
    async userinfo({commit},params){
        let result = await userinfo(params);
        if(result.code == 200){
            commit('userinfo',result.data);
        }
    },
    async getUid({commit}){
        let result = await getUid();
        if(result.code == 200){
            return result.data;
        }
    },
    async enquiry({commit},params){
        let result = await enquiry(params);
        if(result.code != 200){
            return Promise.reject(new Error('faile'))
        }
    },
    async history({commit},params){
        let result = await gethistory(params);
        if(result.code == 200){
            commit('gethistory',result.data);
        }
    },
    async updatehistory({commit},params){
        let result = await updatehistory(params);
    }

    
}
// 操作数据
const mutations = {
    codeStatus(state,val){
        state.msg1 = '';
        if(val.status != 0){
            state.msg1 = val.msg;
        }
        state.codeStatus = val.status;
    },
    regStatus(state,val){
        state.msg1 = '';
        state.msg2 = '';
        if(val.status == 2){
            state.msg1 = val.msg
        } else if(val.status == 1) {
            state.msg2 = val.msg
        }
        state.regStatus = val.status;
    },
    login(state,val){
        state.token=val;
    },
    userinfo(state,val){
        state.userinfo =  val;
    },
    gethistory(state,val){
        state.history = val;
    }
    
}
// 用来将state数据进行加工
const getters = {

}

export default {
    state,
    actions,
    mutations,
    getters
}